export default __webpack_public_path__ + "static/media/process_Development.25b74ac2.png";